import User from './user-container';

export default User;
